export default __webpack_public_path__ + "static/media/MarsCentra-Bold.5d1d7690.woff";